// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"210":"german","347":"english"}[chunkId] || chunkId) + "." + {"210":"f6e4c665","347":"3694d921","498":"9990d42e"}[chunkId] + ".css";
};